import { Instagram, Youtube, Facebook, ArrowUpRight } from "lucide-react";
import { SOCIALS } from "@/constants/socials";

// Custom TikTok icon (lucide-react doesn't ship one)
const TikTokIcon = ({ size = 22 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.83a8.32 8.32 0 0 0 4.85 1.55v-3.5a4.85 4.85 0 0 1-1.92-.19Z" />
  </svg>
);

const ICONS = {
  instagram: <Instagram size={22} />,
  youtube: <Youtube size={22} />,
  facebook: <Facebook size={22} />,
  tiktok: <TikTokIcon size={22} />,
};

export const SocialChannels = () => {
  return (
    <section
      id="social"
      data-testid="social-section"
      className="relative py-24 sm:py-32 bg-[#FAFAFA] border-y border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0052FF] mb-5">
            Stay Connected
          </div>
          <h2
            data-testid="social-headline"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1] text-[#0A0A0A]"
          >
            Follow OperatorAI.
          </h2>
          <p className="mt-5 text-lg text-[#525252]">
            Daily AI workflows, tools, and operator tactics across your
            favorite platforms.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {SOCIALS.map((s) => (
            <a
              key={s.key}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-link-${s.key}`}
              className="group relative bg-white border border-[#E5E5E5] rounded-2xl p-6 sm:p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-[#0A0A0A]/20 hover:bg-white"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#0A0A0A] text-white transition-colors group-hover:bg-[#0052FF]">
                  {ICONS[s.key]}
                </span>
                <ArrowUpRight
                  size={18}
                  className="text-[#9CA3AF] transition-all group-hover:text-[#0052FF] group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                />
              </div>
              <div className="mt-6">
                <h3 className="text-lg font-bold text-[#0A0A0A]">{s.name}</h3>
                <p className="text-sm text-[#525252] mt-1">{s.handle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialChannels;
